import { betTypes } from '../../../enums';

export const BetTypeItem = ({ bet }) => {
  switch (bet.marketType) {
    case betTypes.range:
      return (
        <span>
          [{bet.point}-{bet.point + 4}]
        </span>
      );
    case betTypes.under:
      return (
        <span className='hasArrow'>
          <i className='Triangle' />
          {bet.point}
        </span>
      );
    case betTypes.over:
      return (
        <span className='hasArrow'>
          <i className='Triangle-1' />
          {bet.point}
        </span>
      );
  }
};
